<template>
  <v-card-text class="py-0">
    <v-row v-if="booking">
      <v-col cols="12" xs="11" sm="11">
        <v-row>
          <v-col cols="12" md="1" class="body-2">{{ booking.bookingNo }}</v-col>
          <v-col cols="12" md="2" class="body-2">
            <v-icon v-if="booking.clientName">mdi-city</v-icon>
            {{ booking.clientName }}
            <br />
            <br />
            <v-icon v-if="booking.supplierName">mdi-car-info</v-icon>
            {{ booking.supplierName }}
          </v-col>
          <v-col cols="12" md="2" class="body-2">
            {{
              booking.tariffStructure != null
                ? booking.tariffStructure.name
                : ""
            }}
            <v-btn x-small fab text color="blue">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <br />
            <small>{{ booking.tariffType }}</small>
          </v-col>
          <v-col cols="12" md="3" class="body-2">
            <v-icon>mdi-car-info</v-icon>
            {{ booking.vehicle != null ? booking.vehicle.vehicleType : null }}
            <br />
            <v-btn
              x-small
              color="blue lighten-4"
              v-if="booking.vehicle"
              dark
              style="font-size: 12px; color:#333"
              class="my-2"
            >
              {{
                booking.vehicle != null
                  ? booking.vehicle.vehicleType + " | " + booking.vehicle.regNo
                  : ""
              }}
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              x-small
              color="red lighten-4"
              v-if="!booking.vehicle"
              dark
              style="font-size: 12px; color:#333"
              class="my-2"
            >
              Assign Vehicle
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <br />
            <v-btn
              x-small
              color="teal lighten-5 "
              v-if="booking.driver"
              style="font-size: 12px; color:#333"
            >
              {{ booking.driver != null ? booking.driver.name : null }}
              {{ booking.driver != null ? booking.driver.phone : null }})
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              x-small
              color="red lighten-5"
              v-if="booking.vehicle && !booking.driver"
              dark
              style="font-size: 12px; color:#333"
              class="my-2"
            >
              Assign Driver
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <br />
            <v-btn
              x-small
              color="white"
              style="font-size: 12px; color:#333"
              class="my-2 caption"
              v-if="booking.bookedBy"
            >
              <v-icon>mdi-account</v-icon>
              {{
                booking.bookedBy
                  ? (booking.bookedBy.countryCode
                      ? booking.bookedBy.countryCode
                      : "91") +
                    "-" +
                    booking.bookedBy.phone
                  : ""
              }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="4">
            <small class="text-body-2">
              <v-icon color="green">mdi-map-marker</v-icon>
              {{ booking.startTime | moment("HH:mm DD MMM") }}
              | {{ booking.source.addressLine }} {{ booking.source.city }}
            </small>
            <br />
            <small class="text-body-2">
              <v-icon color="red">mdi-map-marker</v-icon>
              {{ booking.endTime | moment("HH:mm DD MMM") }}
              |
              {{ booking.destination ? booking.destination.addressLine : "" }}
              {{ booking.destination ? booking.destination.city : "" }}
            </small>
            <br />
            <div
              v-if="booking.passengers != null && booking.passengers.length > 0"
            >
              <v-btn-toggle>
                <v-btn
                  x-small
                  color="white"
                  style="font-size: 12px; color:#333"
                  class="my-2 caption"
                >
                  <v-icon>mdi-account</v-icon>
                  {{ booking.passengers[0].name }}
                </v-btn>
                <v-btn
                  v-if="booking.passengers.length > 1"
                  x-small
                  color="white"
                  style="font-size: 12px; color:black"
                  class="my-2"
                  >+ {{ booking.passengers.length - 1 }}</v-btn
                >
              </v-btn-toggle>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="1" sm="1" class="text-center pl-0">
        <v-btn text fab x-small color="blue" :to="'/booking/' + booking._id">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>

        <v-btn text fab x-small color="teal">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
        <v-btn text fab x-small color="red lighten-2">
          <v-icon>mdi-cancel</v-icon>
        </v-btn>
        <v-btn text fab x-small color="grey darken-2">
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";

@Component({
  name: "BookingRow",
  props: {
    value: {
      default: null,
    },
  },
})
export default class BookingRow extends Vue {
  booking = null;

  mounted() {
    if (this.value) this.booking = this.value;
  }

  @Watch("value")
  onValueChange(val) {
    this.booking = val;
  }
}
</script>
